import { Form, InputGroup } from "react-bootstrap";
import IconSearch from "../../assets/images/icon-search.svg"

interface CommonSearchProps {
    className?: string;
}

const CommonSearch: React.FC<CommonSearchProps> = ({ className }) => {
    return (
        <InputGroup className={`common-search-bar me-3${className ? ' ' + className : ''}`}>
            <InputGroup.Text>
                 <img src={IconSearch} alt="Icon" width={16} />
            </InputGroup.Text>
            <Form.Control
                placeholder="Search"
                aria-label="Search"
                className="border-0"
            />
        </InputGroup>
    );
};
export default CommonSearch;